import {Component, OnInit} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {GeliosFieldBaseComponent} from '../gelios-field-base/gelios-field-base.component';
import {TranslateService} from "@ngx-translate/core";
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'app-gelios-audio-field',
  templateUrl: './gelios-audio-field.component.html',
})
export class GeliosAudioFieldComponent extends GeliosFieldBaseComponent implements OnInit {
  public audioSrc: BehaviorSubject<SafeResourceUrl> = new BehaviorSubject<string>(null);
  protected file: any;
  constructor(
    protected sanitizer: DomSanitizer,
    protected translateService: TranslateService
  ) {
    super(translateService);
  }

  // audioSrc() {
  //   return this.reflexiveField.value ?
  //     this.sanitizer.bypassSecurityTrustResourceUrl('data:audio/mpeg;base64,' + this.reflexiveField.value) : '';
  // }
  clearField() {
    this.reflexiveField.value = null;
    this.formGroup.controls[this.fieldName].setValue(this.reflexiveField.value);
  }
  fileInputChanged(e: any) {
    this.file = e.target.files[0];
    if (this.file) {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        this.reflexiveField.value = (fileReader.result as string).split(',')[1];
        this.formGroup.controls[this.fieldName].setValue(this.reflexiveField.value);
        this.audioSrc.next(
          this.reflexiveField.value ?
            this.sanitizer.bypassSecurityTrustResourceUrl('data:audio/mpeg;base64,' + this.reflexiveField.value) : ''
        );
      };
      fileReader.readAsDataURL(this.file);
    }
  }
  ngOnInit() {
    super.ngOnInit();
    this.audioSrc.next(
      this.reflexiveField.value ?
        this.sanitizer.bypassSecurityTrustResourceUrl('data:audio/mpeg;base64,' + this.reflexiveField.value) : ''
    );
  }
}
